// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"449":"83371ed3","453":"c44a0ee9"}[chunkId] + ".chunk.js";
};